<template>
	<section>
		<AsiPageTitle :icon="icons.satelliteDish" :title="$t('pageTitles.admin.services')"/>
		<AsiTabs v-model="activeTab">
			<v-tab key="mailQueue" v-if="rAdmin">
				{{ $t('mailQueue.singular') }}
				<v-icon>{{ icons.envelope }}</v-icon>
			</v-tab>
			<v-tab-item key="mailQueue" v-if="rAdmin">
				<ServicesTabMailQueue :readonly="!rAdmin"/>
			</v-tab-item>
		</AsiTabs>
	</section>
</template>

<script lang="ts">
	import {Component} from 'vue-property-decorator';
	import SettingsTabShipmentTypes from "@/components/settings/admin/SettingsTabShipmentTypes.vue";
	import SettingsTabMailTemplates from "@/components/settings/admin/SettingsTabMailTemplates.vue";
	import SettingsTabPromotions from "@/components/settings/admin/SettingsTabPromotions.vue";
	import SettingsTabPaymentTypes from "@/components/settings/admin/SettingsTabPaymentTypes.vue";
	import AsiPageTitle from "@/components/common/AsiPageTitle.vue";
	import SettingsTabGlobalConfig from "@/components/settings/admin/SettingsTabGlobalConfig.vue";
	import AsiTabs from "@/components/common/AsiTabs";
	import Icon from "@/plugins/icons";
	import {mixins} from "vue-class-component";
	import RightChecks from "@/mixins/RightChecks.vue";
	import ServicesTabMailQueue from "@/components/services/admin/ServicesTabMailQueue.vue";

	@Component({
		components: {
			ServicesTabMailQueue,
			AsiTabs,
			SettingsTabGlobalConfig,
			AsiPageTitle,
			SettingsTabPaymentTypes,
			SettingsTabPromotions,
			SettingsTabMailTemplates,
			SettingsTabShipmentTypes
		}
	})
	export default class Services extends mixins(RightChecks) {

		private icons = Icon;

		private get activeTab(): number {
			return this.$store.getters['ui/activeTabAdmin']('services');
		}

		private set activeTab(index: number) {
			this.$store.commit('ui/activeTabAdmin', {key: 'services', activeTab: index});
		}
	}
</script>


<style scoped lang="scss">

</style>